import { Temporal, Intl, toTemporalInstant } from 'temporal-polyfill'
Date.prototype.toTemporalInstant = toTemporalInstant
